import * as React from 'react';
import ReactDOM from 'react-dom/client';

import L2DApiProvider from '@europrocurement/l2d-domain/providers/L2DApiProvider/L2DApiProvider';
import App from './App';

import ReduxProvider from './ReduxProvider';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

const apiConfiguration = {};

root.render(
    <L2DApiProvider apiConfiguration={apiConfiguration}>
        <React.StrictMode>
            <ReduxProvider>
                <App />
            </ReduxProvider>
        </React.StrictMode>
    </L2DApiProvider>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
